import React from 'react';
import PropTypes from 'prop-types';

import Option from '@components/Option';
import Card from '@components/Card';

function ProductOptionGroups({
  optionGroups,
  onGetTextForOption,
  onShowListOptions,
}) {
  const options =
    optionGroups?.map(op => (
      <Option
        key={op.id}
        id={op.id}
        label={op.name}
        subtitle={onGetTextForOption(op.id)}
        actionText={onGetTextForOption(op.id) ? 'Editar' : 'Seleccionar'}
        onClick={onShowListOptions(op)}
      />
    )) || [];

  if (options.length) return <Card direction="column">{options}</Card>;
  return null;
}

ProductOptionGroups.propTypes = {
  optionGroups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
        }),
      ),
    }),
  ),
  onGetTextForOption: PropTypes.func.isRequired,
  onShowListOptions: PropTypes.func.isRequired,
};

export default React.memo(ProductOptionGroups);
